import { ref } from 'vue'

// Global validation results map for components to access family data
// Maps botanical name (lowercase) to validation result with family
export const globalValidationResults = ref(new Map<string, {
  originalName: string
  matchedName: string | null
  family: string | null
  genus: string | null
  author: string | null
  source: string | null
  score: number
}>())

// Composable for accessing global validation results from other components
export const useGlobalValidationResults = () => {
  return {
    getValidationResults: () => globalValidationResults.value,
    getFamilyForName: (botanicalName: string): string | null => {
      const result = globalValidationResults.value.get(botanicalName.toLowerCase())
      return result?.family || null
    },
    getGenusForName: (botanicalName: string): string | null => {
      const result = globalValidationResults.value.get(botanicalName.toLowerCase())
      return result?.genus || null
    },
    hasValidationResult: (botanicalName: string): boolean => {
      return globalValidationResults.value.has(botanicalName.toLowerCase())
    },
    // Method to update validation results (to be called from NameStatus.vue)
    updateValidationResults: (results: Map<string, {
      originalName: string
      matchedName: string | null
      family: string | null
      genus: string | null
      author: string | null
      source: string | null
      score: number
    }>) => {
      globalValidationResults.value = results
    }
  }
} 